export const submitsTabUIInitialState = {
  showDelForm: false,
  showTransferDelModal: false,
};
